import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=66fae1e5&"
import script from "./TableSettings.vue?vue&type=script&lang=js&"
export * from "./TableSettings.vue?vue&type=script&lang=js&"
import style0 from "./TableSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports